import SendCamera from "./SendCamera.web";
export default SendCamera;
